import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { ja } from 'date-fns/locale';
import Typography from '@material-ui/core/Typography';
import { Modal, InputLabel } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import ShopContact from '../organisms/ShopContact';
import ValidationText from '../../components/atoms/ValidationText';
import {
  sendLogin,
  isAuthenticated,
  resizeImage,
  uploadFile
} from '../../auth/Auth';
import FileUploadReport from '../../components/molecules/FileUploadReport';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmReportShopDialogTextButton from '../../components/atoms/ConfirmReportShopDialogTextButton';
import { sendShopReport, getReportShop } from '../../actions/Shop';
import RequiredButton from '../../components/atoms/RequiredButton';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  mainPaper: {
    margin: 15
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 20,
    textAlign: 'left',
    backgroundColor: '#F7F7F7',
    fontSize: '24 !important'
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24
  },
  mainModal: {
    zIndex: '99999!important'
  },
  buttonWrapper: {
    padding: '20px 20px 1px 20px',
    marginBottom: 39
  },
  button: {
    width: '100%',
    marginBottom: '19px',
    fontSize: 14,
    fontWeight: 'bold'
  },
  supportTimeTxt: {
    fontSize: 14,
    margin: '0 15px 15px'
  },
  twoItems: {
    display: 'flex'
  },
  ml5: {
    marginLeft: 5
  },
  mr5: {
    marginRight: 5
  },
  textSubTitle: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 700
  },
  noBorder: {
    border: 0
  },
  description: {
    fontSize: 18,
    fontWeight: 700,
    marginTop: 5
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  noPaddingTop: {
    paddingTop: 0
  },
  widthInput: {
    width: '100%'
  },
  noMargin: {
    margin: 0
  },
  textField: {
    margin: 0
  },
  inputArea: {
    boxSizing: 'border-box',
    padding: '10px 8px',
    gap: '10px',
    width: '100%',
    height: '150px',
    background: '#FFFFFF',
    border: '1px solid #E9EAEB',
    borderRadius: '4px',
    '&:focus-visible': {
      outlineColor: '#2196F3'
    },
    resize: 'none',
    marginTop: 3
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          sendShopReport,
          getReportShop
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openShopContact', 'setOpenShopContact', false),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('openDialog', 'updateOpenDialog', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('sendReportSuccess', 'updateSendReportSuccess', false),
  withState('textReport', 'setTextReport', ''),
  withState('disabledSubmit', 'setDisabledSubmit', true),
  withState('loading', 'updateLoading', false),
  withState('listMonthReported', 'setListMonthReported', []),
  withState('textError', 'setTextError', ''),
  withState('imageError', 'setImageError', ''),
  withState('monthReport', 'setMonthReport', () => {
    const date = new Date();
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    const year = date.getFullYear();
    console.log('init data: ', `${year}/${month}`);
    const monthYear = moment()
      .tz('Asia/Tokyo')
      .format();
    console.log('monthYear', monthYear);
    return monthYear;
  }),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      const date = new Date();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      const year = date.getFullYear();
      this.props.actions
        .getReportShop(this.props.account.shopId, `${year}-${month}-01`)
        .then(reportShopData => {
          if (
            reportShopData.type === 'GET_REPORT_SHOP_SUCCESS' &&
            reportShopData.payload
          ) {
            this.props.setTextReport(reportShopData.payload.description);
            this.props.setPreviewImage1(
              reportShopData.payload.imageUrl
                ? reportShopData.payload.imageUrl
                : null
            );
            this.props.setListMonthReported(
              reportShopData.payload.listMonthReported
            );
            this.props.setDisabledSubmit(true);
          } else {
            this.props.setTextReport('');
            this.props.setPreviewImage1(null);
            this.props.setDisabledSubmit(false);
          }
        });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    checkSession,
    name,
    handleRedirect,
    openShopContact,
    setOpenShopContact,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    loading,
    updateLoading,
    resultMessage,
    setResultMessage,
    openDialog,
    updateOpenDialog,
    openProgress,
    updateOpenProgress,
    sendReportSuccess,
    updateSendReportSuccess,
    textReport,
    setTextReport,
    monthReport,
    setMonthReport,
    disabledSubmit,
    setDisabledSubmit,
    setListMonthReported,
    textError,
    setTextError,
    imageError,
    setImageError
  }) => {
    const errors = {
      textError,
      imageError
    };

    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }

    const validate = () => {
      let valid = true;
      if (!textReport || textReport.trim() === '') {
        setTextError('必須項目です。');
        valid = false;
      } else {
        setTextError('');
      }

      if (!previewImage1) {
        setImageError('必須項目です。');
        valid = false;
      } else {
        setImageError('');
      }
      return valid;
    };

    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          imagePath: previewImage1
        }
      };
      return imageArray;
    };

    const progressOkAction = () => {
      if (sendReportSuccess) {
        updateOpenProgress(false);
        updateLoading(false);
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const handleChangeMonth = async e => {
      if (e !== '') {
        setDisabledSubmit(false);
        const date = new Date(e);
        let month = date.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }
        const year = date.getFullYear();
        await actions
          .getReportShop(account.shopId, `${year}-${month}-01`)
          .then(reportShopData => {
            if (
              reportShopData.type === 'GET_REPORT_SHOP_SUCCESS' &&
              reportShopData.payload
            ) {
              setTextReport(reportShopData.payload.description);
              setPreviewImage1(
                reportShopData.payload ? reportShopData.payload.imageUrl : null
              );
              setListMonthReported(reportShopData.payload.listMonthReported);
              setDisabledSubmit(true);
            } else {
              setTextReport('');
              setPreviewImage1(null);
              setDisabledSubmit(false);
            }
          });
        setMonthReport(e);
      }
    };

    const sendReportAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const date = new Date(monthReport);
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      const year = date.getFullYear();
      const params = {
        description: textReport.trim(),
        imageUrl: null,
        monthReport: `${year}/${month}`
      };
      const images = convertImages();
      const imagePaths = await Promise.all(
        Object.keys(images).map(async i => {
          if (images[i].image !== null) {
            let { image } = images[i];
            if (image.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
              const { resizeImageFile } = await resizeImage(image);
              image = resizeImageFile;
            }
            const imagePath = await uploadFile(
              'shop',
              `gochi-kid-${account.shopId}`,
              image,
              'public'
            );
            return imagePath;
          }
          if (images[i].imagePath !== null) {
            return images[i].imagePath;
          }
          return null;
        })
      );
      const addImages = imagePaths
        .filter(i => i !== null)
        .map((i, index) => {
          return { image: i, viewOrder: index };
        });
      // if (Object.keys(addImages).length !== 0) {
      // await actions
      //   .addShopImage(account.shopId, {
      //     images: addImages
      //   })
      //   .then(data => checkSession(data));
      // }
      params.imageUrl =
        addImages[0] && addImages[0].image ? addImages[0].image : null;
      const sendReport = await actions
        .sendShopReport(account.shopId, params)
        .then(data => checkSession(data));
      if (sendReport.type === 'SEND_SHOP_REPORT_SUCCESS') {
        await actions
          .getReportShop(account.shopId, `${year}-${month}-01`)
          .then(reportShopData => {
            if (
              reportShopData.type === 'GET_REPORT_SHOP_SUCCESS' &&
              reportShopData.payload
            ) {
              setTextReport(reportShopData.payload.description);
              setPreviewImage1(
                reportShopData.payload ? reportShopData.payload.imageUrl : null
              );
              setListMonthReported(reportShopData.payload.listMonthReported);
              setDisabledSubmit(true);
            } else {
              setTextReport('');
              setPreviewImage1(null);
              setDisabledSubmit(false);
            }
          });
        updateSendReportSuccess(true);
        setResultMessage('投稿が完了しました。');
        updateLoading(false);
      } else {
        updateSendReportSuccess(false);
        if (sendReport.payload.status && sendReport.payload.status === 409) {
          setResultMessage('投稿に失敗しました。もう一度試してください。');
        } else {
          setResultMessage('投稿に失敗しました。もう一度試してください。');
        }
        updateLoading(false);
      }
    };

    const handleChangeText = value => {
      setTextReport(value);
      setTextError('');
    };

    return (
      <div className={classes.root}>
        <Header name={name} />
        <div className={classes.pageTitileDiv}>
          <Typography color="textPrimary" className={classes.textTitle}>
            こどもごちめし
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow className={classes.borderBottom}>
                <TableCell className={classes.textSubTitle}>運営報告</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder]}>
                  <RequiredButton />
                  <div className={classes.description}>報告年月</div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder, classes.noPaddingTop]}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={ja}
                    libInstance={moment}
                  >
                    <div className={classes.boxMargin}>
                      <InputLabel className={classes.inputLabel}>
                        年/月
                      </InputLabel>
                      <DatePicker
                        variant="inline"
                        openTo="month"
                        format="yyyy/MM"
                        views={['year', 'month']}
                        value={monthReport}
                        maxDate={new Date()}
                        onChange={handleChangeMonth}
                      />
                    </div>
                    {/* </Grid> */}
                  </MuiPickersUtilsProvider>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder]}>
                  <RequiredButton />
                  <div className={classes.description}>
                    こどもごちめし用のコメントを入力
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder, classes.noPaddingTop]}>
                  <span>毎月１回のコメント入力</span>
                  <textarea
                    label="毎月１回のコメント入力"
                    placeholder="こどもごちめし用のコメントをご入力ください。"
                    fullWidth
                    multiline
                    rows="4"
                    value={textReport}
                    className={classes.inputArea}
                    margin="normal"
                    onChange={e => {
                      handleChangeText(e.target.value);
                    }}
                    disabled={disabledSubmit}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingTop]}
                  colspan="2"
                >
                  <ValidationText message={errors.textError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder]}>
                  <RequiredButton />
                  <div className={classes.description}>写真を投稿</div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder, classes.noPaddingTop]}>
                  <FileUploadReport
                    label="image"
                    setFile={setImage1}
                    previewImage={previewImage1}
                    setPreviewImage={setPreviewImage1}
                    setImageError={setImageError}
                    isOnlyImage
                    disabledSubmit={disabledSubmit}
                  />
                  {!disabledSubmit && (
                    <div>※8MB以内の画像データをアップロードしてください。</div>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingTop]}
                  colspan="2"
                >
                  <ValidationText message={errors.imageError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  {!disabledSubmit && (
                    <ConfirmReportShopDialogTextButton
                      message="Are you sure?"
                      validate={validate}
                      content="投稿する"
                      openDialog={openDialog}
                      updateOpenDialog={updateOpenDialog}
                      onClickAction={sendReportAction}
                      disabled={disabledSubmit}
                      monthReport={monthReport}
                      previewImage1={previewImage1}
                      textReport={textReport}
                    />
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <MenuBox account={account} />
        <div>
          <Modal open={openShopContact} className={classes.mainModal}>
            <ShopContact setOpenShopContact={setOpenShopContact} />
          </Modal>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
